import React from 'react';
import { withNamespaces } from 'react-i18next';
import { inject, observer } from 'mobx-react';

const PageTitle = ({t, store}) => {
    const { pageTitle } = store.app;

    return (
        <h2 className="page-title align-self-end">
            {t(pageTitle)}
        </h2>
    )
};

export default
inject('store')(
withNamespaces()(
observer(
    PageTitle
)));


// WEBPACK FOOTER //
// ./src/components/base/secure/header/page-title.js